import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { CircularProgress } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import clsx from 'clsx'
import FadeIn from '../../molecules/Transitions/FadeIn'

const SelectButton = forwardRef(function SelectButton ({ open, isLoading, onClick, style, className, children }, anchorRef) {
  return (
    <div
      role='button'
      ref={anchorRef}
      aria-controls={open ? 'menu-list-grow' : undefined}
      aria-haspopup='true'
      onClick={onClick}
      className={clsx('flex gap-2 items-center opal-surface-default hover select-none', className)}
      style={style}
    >
      {isLoading ? (
        <CircularProgress size={54} />
      ) : (
        <>
          <FadeIn className='flex-auto'>
            {children}
          </FadeIn>
          <FadeIn className='flex ml-2'>
            {!open ? (
              <ExpandMoreIcon fontSize='small' />
            ) : (
              <ExpandLessIcon fontSize='small' />
            )}
          </FadeIn>
        </>
      )}
    </div>
  )
})

SelectButton.propTypes = {
  open: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node
}

export default SelectButton
